/* Enhanced Menu - Countdown timer (external to prevent re-init memory leak in Customizer) */
(function(){
  'use strict';

  // Skip entirely when in Shopify Customizer to avoid memory leaks from section reloads
  if (window.Shopify && window.Shopify.designMode) return;

  function startCountdown(){
    var flash = document.querySelector('.em .em-flash');
    if (!flash) return;
    var hEl = flash.querySelector('.em-cd-h');
    var mEl = flash.querySelector('.em-cd-m');
    var sEl = flash.querySelector('.em-cd-s');
    if (!hEl || !mEl || !sEl) return;

    // Clear any previous interval to prevent leaks
    if (window.__emCountdownInterval) {
      clearInterval(window.__emCountdownInterval);
    }

    var key = 'em_cd_target';
    var target = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!target || target < now) {
      target = now + 24 * 3600 * 1000;
      try { localStorage.setItem(key, String(target)); } catch(e) {}
    }

    function pad(n){ return n < 10 ? '0' + n : '' + n; }

    function tick(){
      // Stop if the element was removed from the DOM
      if (!document.body.contains(hEl)) {
        clearInterval(window.__emCountdownInterval);
        window.__emCountdownInterval = null;
        return;
      }
      var diff = Math.max(0, target - Date.now());
      hEl.textContent = pad(Math.floor(diff / 3600000));
      mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    window.__emCountdownInterval = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCountdown);
  } else {
    startCountdown();
  }
})();
